import React, { useEffect } from 'react'
import useBankAccounts from 'tennders-finance/sales-invoice/hooks/useBankAccounts'
import { GSelect } from 'tennders-common/form/components'

const BankAccount = ({ bankAccount }) => (
  bankAccount ? (
    <p>
      Bank : {bankAccount.bankName}<br />
      IBAN : {bankAccount.iban}<br />
      BIC : {bankAccount.bic}<br />
    </p>
  ) : null
)
const MultipleSalesInvoiceFromCompany = ({ fromCompany, toCompany, selectedPaymentTerm, onChange, form, errors }) => {
  const { bankAccounts, fetchBankAccounts } = useBankAccounts()
  useEffect(() => {
    fetchBankAccounts()
  }, [])

  return (
    <>
      <img
        src="/img/logo-black.png"
        width={200}
        alt="Tennders"
        className="mb-16"
      />
      <p>
        {fromCompany?.name}
        {' '}
        <br />
        VAT Code:
        {' '}
        {fromCompany?.nif}
        {' '}
        <br />
        Address:
        {' '}
        {fromCompany?.invoiceAddress}
      </p>
      <div>
        <div className="mb-10">
          <GSelect
            defaultValue=""
            form={form}
            nullValue={0}
            errors={errors}
            disabled={form.id}
            onChange={(k, v) => {
              if (v === 'false') {
                onChange(k, '')
              } else if (v) {
                onChange(k, v)
              }
            }}
            items={bankAccounts}
            name="bankAccount"
            className="smaller form-select w-100"
            label="Select Bank Account"
          />
        </div>
        {form.bankAccount && <BankAccount bankAccount={bankAccounts.find(b => b.id + '' === '' + form.bankAccount)} />}
      </div>
      {selectedPaymentTerm ? (
        <>
          <p>
            <b>Payment Terms:</b>
            {' '}
            {`${selectedPaymentTerm.type?.name || '-'} / ${selectedPaymentTerm?.days || '-'} Days
        ${selectedPaymentTerm?.dateTypeObject ? selectedPaymentTerm.dateTypeObject?.label : ''} / CMR
         ${selectedPaymentTerm.cmrType?.label || ''}`}
          </p>
          <p>
            <b>{selectedPaymentTerm?.discount ? '%' + selectedPaymentTerm.discount + ' Discount' : ''}</b>
          </p>
        </>
      ) : null}
      {toCompany?.discount?.value > 0 ? (
        <p>
          Discount:
          {' '}{toCompany?.discount.value + '%'}
        </p>
      ) : null}
    </>
  )
}

export default MultipleSalesInvoiceFromCompany
